import React, { useState, useEffect } from "react";
import constants from '../../Components/Services/constant';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import { ApiService } from "../../Components/Services/apiservices";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

let apiServices = new ApiService();

function Kalagram() {
    const [pageData, setPageData] = useState({});

    useEffect(() => {
        const dataString = { page_url: "kalagram" };
        apiServices.pagePostRequest(dataString)
            .then((res) => {
                if (res.data.status === "success" && res.data.pageData) {
                    setPageData(res.data.pageData);
                }
            })
            .catch((err) => {
                console.error("Error fetching kalagram page data:", err);
            });
    }, []);

    return (
        <div className="kalagram-page homepage2-wrapper about-us-page">
            <Header />
            <style>
                {`
            .kalagram-banner-responsive {
                background-image: url('/assets/img/food/Kalagram-Desktop-Banner.webp');
            }
            @media (max-width: 768px) {
                .kalagram-banner-responsive {
                    /* REPLACE THIS WITH YOUR MOBILE BANNER IMAGE PATH */
                    background-image: url('/assets/img/food/Kalagram-Banner-Mobile.webp');
                }
            }
            .epd-carousel .swiper-button-next,
            .epd-carousel .swiper-button-prev {
                background-color: rgba(0, 0, 0, 0.6) !important;
                color: #fff !important;
                width: 50px !important;
                height: 50px !important;
                border-radius: 50% !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                margin-top: -25px !important;
            }
            .epd-carousel .swiper-button-next:after,
            .epd-carousel .swiper-button-prev:after {
                font-size: 20px !important;
                font-weight: bold !important;
                line-height: 1 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
            }
        `}
            </style>
            <div
                className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed kalagram-banner-responsive"
                data-overlay-dark="3"
                style={{
                    backgroundSize: "cover",
                    backgroundPosition: "100%",
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center caption mt-90">
                            <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || 'Shop Indian Handicrafts' }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Story Section */}
            <section className="our-story-section text-center" style={{ paddingTop: '80px' }}>
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">{pageData?.metadata?.about_title || 'About Kalagram'}</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        <p className="story-description">
                            {pageData?.metadata?.about_desc_1 || 'Kalagram brings together some of India\'s most unique and authentic handcrafted products, sourced directly from artisans across India. From Kashmir to Kanyakumari, each piece reflects the culture, heritage, and craftsmanship of its region.'}
                        </p>


                    </div>
                </div>

                <div className="container-fluid px-0 mb-5">
                    <div className="story-slider-fullwidth">
                        <Swiper
                            modules={[Navigation, Autoplay, EffectFade]}
                            navigation
                            effect="fade"
                            autoplay={{ delay: 4000, disableOnInteraction: false }}
                            loop={true}
                            slidesPerView={1}
                            className="epd-carousel"
                        >
                            {pageData?.metadata?.kalagram_sliders?.length > 0 ? (
                                pageData.metadata.kalagram_sliders.map((slide, idx) => (
                                    <SwiperSlide key={idx}>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet={slide.mobile_image ? `${constants.IMAGE_URL}${slide.mobile_image}` : `/assets/img/food/Kalagram-Mobile-Slider-${idx + 1}.webp`} />
                                            <img src={`${constants.IMAGE_URL}${slide.image}`} alt={`Kalagram Slide ${idx + 1}`} className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                ))
                            ) : (
                                <>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Kalagram-Mobile-Slider-1.webp" />
                                            <img src="/assets/img/food/Kalagram-Desktop-Slider-1.webp" alt="Kalagram Slide 1" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Kalagram-Mobile-Slider-2.webp" />
                                            <img src="/assets/img/food/Kalagram-Desktop-Slider-2.webp" alt="Kalagram Slide 2" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <picture>
                                            <source media="(max-width: 768px)" srcSet="/assets/img/food/Kalagram-Mobile-Slider-3.webp" />
                                            <img src="/assets/img/food/Kalagram-Desktop-Slider-3.webp" alt="Kalagram Slide 3" className="img-fluid full-width-img" style={{ height: 'auto', width: '100%' }} />
                                        </picture>
                                    </SwiperSlide>
                                </>
                            )}
                        </Swiper>
                    </div>
                </div>

                <div className="container mb-5 text-center">
                    <div className="story-text-container-full mb-5">
                        <p className="story-description">
                            {pageData?.metadata?.about_desc_2 || 'A curated collection of these handcrafted treasures is displayed throughout the restaurant, allowing guests to experience India\'s artistic diversity while they dine. Many of the products are also available for purchase, offering a meaningful connection to the stories and traditions behind each creation.'}
                        </p>
                        <div className="mt-5 mb-5">
                            <a href={pageData?.metadata?.catalog_url || 'https://www.chokhidhani.co.uk/csadmin/public/img/uploads/menu/explore-kalagram.pdf'} target="_blank" rel="noopener noreferrer" className="btn-story-readmore" style={{ padding: '12px 30px' }}>View Catalog</a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default Kalagram;